import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LottieComponent} from './lottie/lottie.component';

@NgModule({
  declarations: [
    LottieComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    LottieComponent
  ]
})
export class LottieModule {
}
